import { render, staticRenderFns } from "./CurriculumEdit.vue?vue&type=template&id=15f6bc2a&"
import script from "./CurriculumEdit.vue?vue&type=script&lang=js&"
export * from "./CurriculumEdit.vue?vue&type=script&lang=js&"
import style0 from "./CurriculumEdit.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&scpoed=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports